module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-2-5f31700bb5d37307817a9d5fabfbbba2.png";